var map = {
	"./about-us.svg": 760,
	"./betting-icon.svg": 761,
	"./bonus.svg": 762,
	"./coin.png": 763,
	"./contact-us.svg": 764,
	"./download-app.svg": 765,
	"./edit-btn.svg": 766,
	"./feedback.svg": 767,
	"./global.svg": 768,
	"./info-centre.svg": 769,
	"./instant-rebate.svg": 770,
	"./mall-icon.svg": 771,
	"./message.svg": 772,
	"./redemption-icon.svg": 773,
	"./referral.svg": 774,
	"./resp-gaming.svg": 775,
	"./security.svg": 776,
	"./transaction-icon.svg": 777,
	"./vip-icon.svg": 778,
	"./wallet-icon.svg": 779
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2369;